export const TIPS_STATUS = {
  INITIAL: 'INITIAL',
  FAILURE: 'FAILURE',
  SUCCESS: 'SUCCESS',
};
